import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingCart } from "lucide-react";
import Logo from "../assets/IMG_20250319_200040_568 - Copy.svg";
import { CartContext } from "../context/CartContext"; // Import CartContext

function Navbar() {
  const { getTotalCartCount } = useContext(CartContext);
  const cartCount = getTotalCartCount();

  return (
    <nav className="bg-grey text-white py-4 px-6">
      <div className="container mx-auto flex justify-between items-center">
        
        <div>
          <Link to="/">
            <img src={Logo} alt="Gridograph Logo" className="w-[181px] h-[62px]" />
          </Link>
        </div>

        {/* Navigation Links */}
        <ul className="hidden md:flex space-x-10 text-lg font-medium">
          <li className="hover:text-orange transition">
            <Link to="/">Home</Link>
          </li>
          <li className="hover:text-orange transition">
            <Link to="/collection">Collection</Link>
          </li>
          <li className="hover:text-orange transition">
            <Link to="/contact">Contact</Link>
          </li>
        </ul>

        {/* Icons */}
        <div className="flex space-x-6 relative">
          <Link to="/">
            <Heart className="w-6 h-6 hover:text-orange cursor-pointer" />
          </Link>

          {/* Cart Icon with Badge */}
          <Link to="/cart" className="relative">
            <ShoppingCart className="w-6 h-6 hover:text-orange cursor-pointer" />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex justify-center items-center rounded-full">
                {cartCount}
              </span>
            )}
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
